import {
	OrgSettingsUsersState,
	ORG_SETTINGS_USERS_ACTIONS_TYPES,
	OrgSettingsCoachesActions,
} from './types'

const initialState: OrgSettingsUsersState = {
	list: [],
	searchValue: '',
	filters: {
		organization: [],
		roles: [],
		tier: [],
		proTitle: [],
		expertise: [],
		lang: [],
		dateStarted: 0,
	},
}

export default (
	state: OrgSettingsUsersState = initialState,
	action: OrgSettingsCoachesActions
): OrgSettingsUsersState => {
	switch (action.type) {
		case ORG_SETTINGS_USERS_ACTIONS_TYPES.GET: {
			return {
				...state,
				list: action.payload,
			}
		}
		case ORG_SETTINGS_USERS_ACTIONS_TYPES.SET_SEARCH_VALUE: {
			return {
				...state,
				searchValue: action.payload,
			}
		}
		case ORG_SETTINGS_USERS_ACTIONS_TYPES.SET_FILTER_VALUE: {
			const newFilters = {
				...state.filters,
				[action.payload.key]: [
					...state.filters[action.payload.key],
					action.payload.value,
				],
			}

			return {
				...state,
				filters: newFilters,
			}
		}
		case ORG_SETTINGS_USERS_ACTIONS_TYPES.SET_DATE_STARTED_FILTER_VALUE: {
			return {
				...state,
				filters: {
					...state.filters,
					dateStarted: action.payload,
				},
			}
		}
		case ORG_SETTINGS_USERS_ACTIONS_TYPES.UNSET_FILTER_VALUE: {
			const newFilters = {
				...state.filters,
				[action.payload.key]: state.filters[action.payload.key].filter(
					item => item !== action.payload.value
				),
			}

			return {
				...state,
				filters: newFilters,
			}
		}
		case ORG_SETTINGS_USERS_ACTIONS_TYPES.RESET: {
			return initialState
		}
		default: {
			return state
		}
	}
}
